export default __webpack_public_path__ + "static/media/6 Customer Service Desk REP.6a8ae925.jpg";